import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useMonitoring } from '../context/MonitoringContext';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';

export default function Layout() {
    const { theme } = useTheme();
    const { toast } = useMonitoring();
    const { user } = useAuth();

    // CAGlobal accounts have no sidebar — they only see the Dashboard
    const isCAGlobal = user?.role?.toLowerCase() === 'caglobal';

    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        return localStorage.getItem('sidebarCollapsed') === 'true';
    });

    const toggleSidebar = () => {
        setSidebarCollapsed((prev) => {
            const next = !prev;
            localStorage.setItem('sidebarCollapsed', String(next));
            return next;
        });
    };

    return (
        <div className={`portal-layout ${theme === 'dark' ? 'theme-dark' : 'theme-light'}`}>
            {toast && <div className="portal-toast">{toast}</div>}

            {/* Sidebar is hidden entirely for CAGlobal role */}
            {!isCAGlobal && (
                <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={toggleSidebar} />
            )}

            <main className={`portal-main-content${isCAGlobal ? ' portal-main-content--full' : ''}`}>
                <Outlet />
            </main>
        </div>
    );
}